import { createPortal } from "react-dom";
import { CheckCircle } from "lucide-react";
import { Button } from "@repo/ui";

interface CompletionModalProps {
  onEnregistrer: () => void;
}

export function CompletionModal({ onEnregistrer }: CompletionModalProps) {
  return createPortal(
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm p-4">
      <div
        className="relative w-full max-w-md rounded-xl bg-background shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="px-8 py-10 text-center space-y-6">
          <div className="flex justify-center">
            <div className="flex h-20 w-20 items-center justify-center rounded-full bg-green-100 dark:bg-green-950/40">
              <CheckCircle className="h-10 w-10 text-green-600 dark:text-green-400" />
            </div>
          </div>

          <div className="space-y-2">
            <h2 className="text-xl font-semibold text-foreground">
              Évaluation terminée
            </h2>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Vous avez répondu à l'intégralité des questions. Merci pour votre participation.
            </p>
          </div>

          <Button onClick={onEnregistrer} className="w-full">
            Enregistrer
          </Button>
        </div>
      </div>
    </div>,
    document.body,
  );
}
